<template>
    <router-link v-if="to !== undefined" :to="to">
        <v-btn rounded="xl" elevation="0" color="primary"><slot/></v-btn>
    </router-link>
    <v-btn rounded="xl" v-else color="primary"><slot/></v-btn>
</template>

<script>
    export default {
        name: 'PrimaryButton',

        props: {
            to: Object
        },
    }
</script>

<style scoped>
    a {
        text-decoration: none !important;
    }

    .v-btn {
        color: white !important;
        box-shadow: none;
        height: 3em;
    }
</style>